module.exports = __webpack_public_path__ + "images/FUSA_icons/063-like.85084694f2017dcb94fbf8b882f4737c.svg";